import { createApp } from "vue";
import SupportApp from "./components/SupportPage.vue";
import "./plugins/AdobeTypekit.js";
import "vuetify/dist/vuetify.min.css";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";

// Vuetifyのインポート
import { createVuetify } from "vuetify";

// Vuetifyの設定 カラーテーマの設定もここ
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        dark: true,
        colors: {
          primary: "#beb484", //1a237e
          secondary: "#212121",
          info: "#C62828",
          warning: "#FFE57F",
        },
      },
    },
    options: { customProperties: true },
  },
});

const app = createApp(SupportApp);

// Vuetifyを使うように設定
app.use(vuetify);

app.mount("#app");
